export default "__VITE_ASSET__fa6fd7e7__"